import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';

export async function getOcrPureTextExtension(): Promise<{
    show(props: any): void,
    hide(): void,
}> {
    const ocrExtension = await ArkLoader.extensionService.getExtension(componentConfig.name);
    return ocrExtension;
}
